module.exports = __webpack_public_path__ + "img/avatar-8.7be5b7ea.jpg";